import React from 'react';

const MaterialOverviewRightMenu = () => {
  return <></>;
};

export default MaterialOverviewRightMenu;
